import React from 'react'
import { TableHead, TableRow, TableCell } from 'transfix-ui'

export const CapacityTableHeader = () => (
  <TableHead>
    <TableRow>
      <TableCell>Empty Location</TableCell>
      <TableCell>Radius</TableCell>
      <TableCell>Weekly Capacity</TableCell>
      <TableCell>Added by</TableCell>
    </TableRow>
  </TableHead>
)
